import { Checkbox, CheckboxProps } from "@heroui/react";
import { Controller, useFormContext } from "react-hook-form";

function CheckboxInput({
    name,
    label,
    ...rest
}: {
    name: string;
    label?: string;
} & Partial<CheckboxProps>) {
    const f = useFormContext();
    return (
        <Controller
            name={name}
            control={f.control}
            render={({ field: { value, onChange, onBlur } }) => {
                return (
                    <Checkbox
                        isSelected={value}
                        onValueChange={onChange}
                        onBlur={onBlur}
                        {...rest}
                    >
                        {label}
                    </Checkbox>
                );
            }}
        />
    );
}

export default CheckboxInput;
